import type { ElementType, ReactNode } from 'react';
import { InfoCard } from '@/components/shared/info-card';

const GRADIENT = 'linear-gradient(90deg, #FF2BD1 0%, #00AAED 100%)';

interface NewFeedbackCardProps {
  children: ReactNode;
  icon: ElementType;
  onClick: () => void;
  iconSpacing?: number;
  contentMaxWidth?: string;
}

export const NewFeedbackCard = ({
  children,
  icon,
  onClick,
  iconSpacing,
  contentMaxWidth,
}: NewFeedbackCardProps) => (
  <InfoCard
    icon={icon}
    iconSpacing={iconSpacing}
    contentMaxWidth={contentMaxWidth}
    sx={(theme) => ({
      position: 'relative',
      overflow: 'hidden',
      borderRadius: `${theme.shape.borderRadius}px`,
      '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        padding: '2px',
        borderRadius: `${theme.shape.borderRadius}px`,
        background: GRADIENT,
        WebkitMask:
          'linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)',
        WebkitMaskComposite: 'xor',
        maskComposite: 'exclude',
      },
    })}
    onClick={onClick}
  >
    {children}
  </InfoCard>
);
